import { DEFAULT_WORKSPACE_PAGE, ROUTER_PATH } from "../config/constants";

export const getPageForPathname = (pathname = "") => {
  const found = Object.entries(ROUTER_PATH).find(
    ([, route]) => route === pathname,
  );
  return found ? found[0] : DEFAULT_WORKSPACE_PAGE;
};
